import { render, staticRenderFns } from "./DocUploadComponent.vue?vue&type=template&id=54ec168c&scoped=true&"
import script from "./DocUploadComponent.vue?vue&type=script&lang=js&"
export * from "./DocUploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec168c",
  null
  
)

export default component.exports